import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { FaAngleLeft } from 'react-icons/fa';
import Schematics from './schematics';
import Videos from './videos';
import ProcessInfo from './processInfo';
import Layout from '../../../Components/layout/Layout';
import {
  LoadProcedureOnRequest,
  LoadProceduresRequest,
  LoadProceduresRequestEnd,
  ResetProcedure,
  SetPreviousRoute,
} from '../../../Redux/ProcedureReducer';
import { api } from '../../../Api-Endpoints/apiEndpoint';
import { useNavigate } from 'react-router-dom';

function Preview() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { procedure, isGotProcedure } = useSelector(
    state => ({
      procedure: state.Procedure.procedure,
      isGotProcedure: state.Procedure.isGotProcedure,
    }),
    shallowEqual
  );
  const [procedureDetails, setProcedurDetails] = useState('');

  useEffect(() => {
    const fetchProcedureDetails = async () => {
      if (isGotProcedure) {
        setProcedurDetails(procedure);
        dispatch(ResetProcedure());
      } else {
        const id = window.location.pathname.split('/').pop();

        try {
          const { status, data } = await api.get(`procedure/by/${id}`);

          if (status === 200) {
            setProcedurDetails(data[0]);
            dispatch(ResetProcedure());
          }
        } catch (error) {
          console.error('Error fetching procedure details:', error);
        }
      }
    };

    fetchProcedureDetails();
  }, [isGotProcedure]);

  const qrHandle = async () => {
    const id = window.location.pathname.split('/').pop();
    const { status, data } = await api.get(`procedure/to/qr/${id}`);
    if (status === 200) {
      setProcedurDetails(data[0]);
      dispatch(ResetProcedure());
    }
  };

  const downloadHandle = async url => {
    window.open(url);
  };
  const { previousRoute } = useSelector(
    state => ({
      previousRoute: state.Procedure.previousRoute,
    }),
    shallowEqual
  );
  const { user } = useSelector(
    state => ({
      user: state.User.user,
    }),
    shallowEqual
  );
  const handleBack = async () => {
    dispatch(LoadProceduresRequest());
    if (previousRoute.length > 0) {
      const lastRoute = previousRoute[previousRoute.length - 1];
      navigate(lastRoute);
      const route = [...previousRoute.slice(0, -1)];
      dispatch(SetPreviousRoute(route));
      const id = lastRoute.split('/')[2];
      if (id) {
        const { status, data } = await api.get(
          `/procedure/getProcedureByFolderId?id=${id}`
        );
        const fetchedProc = data?.procedures[0]?.procedures || [];
        if (user?.role?.includes('admin')) {
          if (status === 200) {
            dispatch(LoadProcedureOnRequest(fetchedProc));
            navigate(`/procedures/${id}`);
          }
        } else {
          const usersProc = await getProcedureByUserId(user?._id);
          const similarObjects = fetchedProc.filter(fetched =>
            usersProc.some(user => user._id === fetched._id)
          );
          dispatch(LoadProcedureOnRequest(similarObjects));
          navigate(`/procedures/${id}`);
        }
      } else {
      }
    }
    dispatch(LoadProceduresRequestEnd());
  };
  const getProcedureByUserId = async id => {
    try {
      const { status, data } = await api.get(
        `/procedure/proceduregetbyuser/${id}`
      );
      if (status === 200) {
        dispatch(LoadProcedureOnRequest(data?.procedures || []));
        return data?.procedures || [];
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <Layout heading={'Preview Procedure'}>
      <div className="w-[100%] ">
        <div className="p-6">
          {/* Table of Contents Section */}
          <section id="table-of-contents" className="mb-4">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center justify-between ">
                  <div>
                    <h1 className="text-3xl font-bold ">{procedure?.name}</h1>
                    <p className="">
                      by{' '}
                      {procedure?.author ? procedure?.author : 'unknown author'}{' '}
                      at{' '}
                      {procedure?.publishedAt
                        ? procedure.publishedAt.split('T')[0]
                        : '00:00:00'}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center">
                <div className="mt-4 self-end">
                  <button
                    onClick={() => handleBack()}
                    className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
                  >
                    <FaAngleLeft className="w-5 h-5" />
                    <span>back</span>
                  </button>
                </div>
                <center>
                  {procedure?.url === '' ? (
                    <button
                      onClick={qrHandle}
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition"
                    >
                      Create New QR Code
                    </button>
                  ) : (
                    <img
                      src={procedureDetails?.url}
                      alt="QrCode"
                      className="object-cover rounded-lg shadow-lg cursor-pointer pt-5"
                      style={{ height: '250px', width: '250px' }}
                      onClick={() => downloadHandle(procedureDetails?.url)}
                    />
                  )}
                </center>
                <div
                  className="flex item-end
                justify-end "
                >
                  <p className="text-sm">
                    version {procedure?.version ? procedure?.version : 0.0}
                  </p>
                </div>
              </div>
            </div>
            <h2 className="text-1xl font-bold mb-4">Safety Notes</h2>

            <ul className="list-disc list-inside">
              <li>
                <a href="#schematics" className="text-blue-500 hover:underline">
                  {procedureDetails?.procedureSafetyNote?.title ??
                    'Untitled Safety Note'}
                </a>
              </li>
            </ul>

            <h2 className="text-1xl font-bold mb-4">Steps and Decisions</h2>

            <ul className="list-disc list-inside">
              {procedureDetails?.procedures?.map(item =>
                item?.steps ? (
                  <li id={`${item?._id}`}>
                    <a
                      href={`#${item?.steps?.title}`}
                      className="text-blue-500 hover:underline"
                    >
                      {item?.steps?.title || 'Untitled Step'}
                    </a>
                  </li>
                ) : (
                  <li id={`${item?._id}`}>
                    <a
                      href={`#${item?.decisions?.title}`}
                      className="text-blue-500 hover:underline"
                    >
                      {item?.decisions?.title || 'Untitled Decision'}
                    </a>
                  </li>
                )
              )}
            </ul>
          </section>

          {/* Schematics Section */}
          <Schematics procedure={procedureDetails} />

          {/* Videos Section */}
          <Videos procedure={procedureDetails} />

          {/* Process Info Section */}
          <section id="process-info">
            <h2 className="text-2xl font-bold mb-3">Process Info</h2>
            <ProcessInfo procedure={procedureDetails} />

            {/* <div className="p-6">
                <div className="flex flex-row items-start space-x-8">
                  <div className="flex-1">
                    <ProcessInfo procedure={procedureDetails} />
                  </div>

                  <div className="flex-1">
                    <ProcessFlow procedure={procedureDetails} />
                  </div>
                </div>
              </div> */}
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Preview;
